module.exports = "/_next/static/images/loading_24-b5e0bec10c3207138d1bbb372e5a2bd0.png";